import TemplateView from '../../../../TemplateView'
import messageResource from "../../../../messageResource";

export const Type = {
    DEPARTMENT: 'department',
    TIME_ZONE_GROUP: 'timeZoneGroup',
}

export default class GroupItem extends TemplateView {
    constructor({
        type = Type.DEPARTMENT,
        additionalClass = '',
        onClick = (type) => {},
    }) {
        super(null)

        this.type = type
        this.additionalClass = additionalClass
        this.onClick = onClick

        this.text = type === Type.DEPARTMENT
            ? messageResource.getMessage('userlist.manage_user_groups')
            : messageResource.getMessage('userlist.manage_time_zone_groups')
    }

    afterRender() {
        this.$el.on('click', () => {this.onClick(this.type)})
    }

    templateHtml() {
        return '<div class="userList_manageButtons_component_groupItem <%=type%> <%=additionalClass%>">' +
               '  <%-text%>' +
               '</div>'
    }
}




// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/GroupItem.js